import React, { Component } from "react";
import CardList from "../components/CardList";
// import { robots } from "./robots"; //destructured with the { x } because we aren't exporting defaults since robots can be updated. We are also allowed to grab multiple items from robots by doing { x,y }

import SearchBox from "../components/SearchBox";
import "./App.css";
import Scroll from "../components/Scroll.js";
import ErrorBoundary from "../components/ErrorBoundary.js";

class App extends Component {
  //the app component contains 2 states. Robots and state field. The state are properties that are allowed to change. We are allowed to change the searchfield to filter the robots that appear
  constructor() {
    super(); //a required function for constructors
    this.state = {
      robots: [],
      searchfield: "",
    };
  }

  componentDidMount() {
    fetch("https://jsonplaceholder.typicode.com/users")
      .then((response) => response.json())
      .then((users) => this.setState({ robots: users }));
  }

  onSearchChange = (event) => {
    //updates the state of the searchfield (whats typed in it)
    this.setState({ searchfield: event.target.value });
  };
  render() {
    //the state is managed here and the App component is the only thing actually changing values.
    const filteredRobots = this.state.robots.filter((robot) => {
      //instead of displaying all the robots, shows what's allowed in the new filtered list using the filter() function as it creates a new array that is displayed below in the <CardList robots={filteredRobots}
      return robot.name
        .toLowerCase()
        .includes(this.state.searchfield.toLowerCase());
    });
    if (this.state.robots.length === 0) {
      return <h1>Loading</h1>;
    } else {
      return (
        <div className="tc">
          <h1 className="f1">Bot Buddy</h1>
          <SearchBox searchChange={this.onSearchChange} />
          <Scroll>
            <ErrorBoundary>
              <CardList robots={filteredRobots} />
            </ErrorBoundary>
          </Scroll>
        </div>
      );
    }
  }
}

export default App;
